<form *dynamicFormInfo="formInfo" (keyup.enter)="search()">
  <div class="row">
    <div class="col-5">
      <app-text-input
        controlName="insurerWNumber"
        hint="WC Insurer ID must be formatted as 'W' followed by six digits."
        tooltipText="Required format: W000000"
      ></app-text-input>
    </div>

    <div class="col-5">
      <app-text-input
        controlName="insurerBNumber"
        hint="DB Insurer ID must be formatted as 'B' followed by six digits."
        tooltipText="Required format: B000000"
      ></app-text-input>
    </div>
  </div>

  <div class="row">
    <div class="col-2">
      <app-select-input
        #nameSearchOptionTypeList
        controlName="nameSearchOptionType"
        [showNullPlaceholder]="false"
      ></app-select-input>
    </div>
    <div class="col-4">
      <app-generic-input approvedNameCharacters controlName="insurerName"></app-generic-input>
    </div>

    <div class="col-4">
      <app-text-input
        #feinTemplate
        controlName="fein"
        [hint]="FieldLabelConstants.InsurerFeinMustBeNineDigits"
        [maskConfig]="feinMaskConfig"
        (input)="onFeinChange()"
        tooltipText="Required format: 00-0000000"
      ></app-text-input>
    </div>
  </div>
</form>
